<template>
	<div>
		<el-card class="box-card">
			<el-row>
				<el-col :span="4">
					<el-avatar style="width:60px;height:60px;float: left;" size="large" :src="res.shop.head_img">
					</el-avatar>
					<h3 style="color:rgb(64, 158, 255);float: left;">{{res.shop.user_name}}</h3>
				</el-col>
				<el-col :span="6" style="margin-top: 20px;">
					<i style="color:rgb(64, 158, 255);" class="el-icon-money"> </i><span> 可用余额：</span>
					<span style="color:red;"> {{res.shop.money}}</span>
					<el-button @click="cz" type="success" round>充值</el-button>
				</el-col>
			</el-row>
		</el-card>

		<el-card class="box-card" style="margin-top: 10px;">
			<weekEcharts :xAxis_data="echarts.xAxis_data" :y_one="echarts.y1" :y_two="echarts.y2"></weekEcharts>
		</el-card>

		<el-card class="box-card" style="margin-top: 10px;">
			<el-descriptions title="任务">
				<el-descriptions-item label="进行中任务">
					<el-link @click="href1" type="primary">{{res.ing_task}}</el-link>
				</el-descriptions-item>
				<el-descriptions-item label="已完成任务">
					<el-link @click="href1" type="primary">{{res.complete_task}}</el-link>
				</el-descriptions-item>
			</el-descriptions>
		</el-card>

		<el-card class="box-card" style="margin-top: 10px;">
			<el-descriptions title="订单">
				<el-descriptions-item label="已接单订单">
					<el-link @click="href2" type="primary">{{res.accept_order}}</el-link>
				</el-descriptions-item>
				<el-descriptions-item label="已下单订单">
					<el-link @click="href2" type="primary">{{res.down_order}}</el-link>
				</el-descriptions-item>
				<el-descriptions-item label="已发货订单">
					<el-link @click="href2" type="primary">{{res.send_order}}</el-link>
				</el-descriptions-item>
				<el-descriptions-item label="已收货订单">
					<el-link @click="href2" type="primary">{{res.receipt_order}}</el-link>
				</el-descriptions-item>
				<el-descriptions-item label="已评价订单">
					<el-link @click="href2" type="primary">{{res.appraise_order}}</el-link>
				</el-descriptions-item>
				<el-descriptions-item label="已取消订单">
					<el-link @click="href2" type="primary">{{res.cancel_order}}</el-link>
				</el-descriptions-item>
			</el-descriptions>
		</el-card>

		<!-- <el-card class="box-card" style="margin-top: 10px;">
			<el-descriptions title="待办事项">
				<el-descriptions-item label="未读站内信">
					<el-link @click="href3" type="danger">{{res.no_read_msg}}</el-link>
				</el-descriptions-item>
			</el-descriptions>
		</el-card> -->

		<el-card class="box-card" style="margin-top: 10px;">
			<el-descriptions title="在线客服" direction="vertical" :column="4">
				<el-descriptions-item label="QQ">
					<el-link type="primary" :href="res.qq" target="_bank">
						<el-image style="width: 92px; height: 22px" src="/QQ.png" fit="fill"></el-image>
					</el-link>
				</el-descriptions-item>
				<el-descriptions-item label="微信">
					<el-image style="width: 140px; height: 140px" :src="res.wx" fit="fill"></el-image>
				</el-descriptions-item>
			</el-descriptions>
		</el-card>
	</div>
</template>

<script>
	import {
		index,
		msgRead
	} from '@/api/jd_task'
	import Qs from 'qs'
	import weekEcharts from '@/components/Jd/weekEcharts'
	export default {
		name: 'Dashboard',
		components: {
			weekEcharts
		},
		data() {
			return {
				res: {
					'ing_task': 0,
					'complete_task': 0,
					'accept_order': 0,
					'down_order': 0,
					'send_order': 0,
					'receipt_order': 0,
					'appraise_order': 0,
					'cancel_order': 0,
					'qq': '',
					'wx': '',
					'shop': {},
					'no_read_msg': 0,
				},
				echarts: {
					xAxis_data: [],
					y1: [],
					y2: []
				}
			}
		},
		created() {
			this.getData();
		},
		methods: {
			getData() {
				index(Qs.stringify()).then(response => {
					let r = response.result;
					this.res.ing_task = r.ing_task;
					this.res.complete_task = r.complete_task;
					this.res.accept_order = r.accept_order;
					this.res.down_order = r.down_order;
					this.res.send_order = r.send_order;
					this.res.receipt_order = r.receipt_order;
					this.res.appraise_order = r.appraise_order;
					this.res.cancel_order = r.cancel_order;
					this.res.qq = "https://wpa.qq.com/msgrd?v=3&uin=" + r.kf.qq + "&site=qq&menu=yes";
					this.res.wx = r.kf.wx;
					this.res.shop = r.shop;
					this.res.no_read_msg = r.no_read_msg;
					if (r.no_read_msg > 0) {
						this.$store.commit('set_anx', true);
					}
					// 图表的数据
					this.echarts.xAxis_data = r.week_task.week;
					this.echarts.y1 = r.week_task.pub;
					this.echarts.y2 = r.week_task.draw;

					//  未读消息的提醒
					this.notice_alert(r.no_read_notice);
				})
			},
			href1() {
				//路由跳转
				this.$router.push({
					path: '/jd_task/list',
				});
			},
			href2() {
				//路由跳转
				this.$router.push({
					path: '/jd_task/order_list',
				});
			},
			href3() {
				//路由跳转
				this.$router.push({
					path: '/jd_task/message',
				});
			},
			cz() {
				//路由跳转
				this.$router.push({
					path: '/jd_task/recharge_pay',
				});
			},
			// 未读消息的弹框提醒
			notice_alert(msg) {
				this.notice(msg,0);
			},
			notice(msg,index){
				if(msg[index]){
					let item = msg[index];
					
					this.$confirm(item.msg, '平台通知', {
						confirmButtonText: '已读',
						cancelButtonText: '稍后提示',
						type: 'warning'
					}).then(() => {
						// 已读操作
						this.read(item.id);
						index+=1;
						this.notice(msg,index);
					}).catch(() => {
						// 稍后提示操作
						
						index+=1;
						this.notice(msg,index);
					});
				}
			},
			// 消息设置为已读
			read(id) {
				let post = {
					'ids': [id]
				};
				msgRead(Qs.stringify(post)).then(response => {
					
				})
			}
		}
	}
</script>

<style>
</style>
